// extracted by mini-css-extract-plugin
module.exports = {"loadImg":"asyncImage_loadImg__3yIQ3"};